import React from "react";
import {Modal} from "semantic-ui-react";
import './getCoursePaymentDetails.scss'
import {lang, language} from "../../../const/language";
import Row from "react-bootstrap/Row";
import {Col} from "reactstrap";
import {Dropdown} from "semantic-ui-react";
import {Button} from "reactstrap";
import * as courseService from '../../../services/courses'
import * as constants from "../../../const/constants";
import toastr from 'toastr';
import GetCoursePaymentDetails from "./getCoursePaymentDetails";

class getPaymentModel extends React.Component {
    state = {
        paymentType: [
            {
                key: 1,
                value: "FULL",
                text: "එකවර ගෙවීම(Full payment)"
            },
            {
                key: 2,
                value: "INSTALLMENTS",
                text: "වාරික වශයෙන් ගෙවීම(Payment in installments)"
            }
        ],
        selectedPaymentType: '',
        courseId: '',
        enrollSuccess: false,
        styleVisibale:false
    };

    componentDidMount() {
        this.setState({courseId: this.props.courseId});

    }

    onSelectPayment = async (event, data) => {
        await this.setState({selectedPaymentType: data.value})
    };

    setEnrollment = async () => {
        if (this.state.selectedPaymentType === '') {
            await this.setState({styleVisibale: true})
        }else{

            let enrollDetails = {
                courseId: this.state.courseId,
                courseEnrollType: this.state.selectedPaymentType
            };


            this.setState({enrollSuccess: true});
            // msgType = 'success';
            // toastr[msgType](res.message);
            let firstPaymentId = '';
            let totalPayment = '';

            {
                this.state.selectedPaymentType === 'INSTALLMENTS' ?
                    firstPaymentId = this.props.courseDetails.courseInstallmentList[0].id :
                    firstPaymentId = ''
            }
            {
                this.state.selectedPaymentType === 'FULL' ?
                    totalPayment = this.props.courseDetails.totalFee : totalPayment = ''
            }
            // console.log(firstPaymentId);
            let courseProps = {
                courseId: this.state.courseId,
                courseDetails: this.props.courseDetails,
                userType: this.props.userType,
                installmentId: firstPaymentId,
                showPayment: true,
                totalPayment: totalPayment,
                installmentPayment: this.props.courseDetails.courseInstallmentList[0].amount

            };
            console.log(courseProps);

        if (this.props.secondNav) {
                this.props.closeModal(courseProps);
                this.props.paymentModal();
                // // console.log(courseProps);

            }else {
                this.props.history.push({
                    pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_COURSE_ROUTE}`,
                    state: courseProps
                });

            }
        }
    };

    render() {

        return (
            <Modal size={"tiny"} open={true} centered={true} className='getCoursePaymentDetails'>
                <Modal.Header>
                    <div className={"header-wrapper"}>
                        <p>{language[lang].selectPaymentMethod}</p>
                        <div align="right"><i className="fa fa-close" aria-hidden="true"
                                              onClick={this.props.closeModal}/></div>
                    </div>
                </Modal.Header>
                <Modal.Content>
                    {/*<h2>{this.props.courseID}</h2>*/}
                    <Row style={{marginBottom: '10px'}}>
                        <Col xs={12} className={"card-section"}>
                            <strong style={{paddingBottom:'50px'}}>Select Payment Type</strong>
                            <br/>
                                {this.state.styleVisibale?<small style={{color:"red"}}>Select Payment Type to continue !</small>:null}
                            <Dropdown
                                style={{borderColor:this.state.styleVisibale ?'red':'none',marginTop:'1%'}}
                                placeholder='Select a payment type'
                                fluid
                                selection
                                clearable
                                options={this.state.paymentType}
                                onChange={this.onSelectPayment}
                                value={this.state.selectedPaymentType}
                                className="mb-4"
                            />
                        </Col>



                        <Col xs={12}>
                            {this.state.selectedPaymentType != '' ?
                                <p>{this.state.selectedPaymentType === 'INSTALLMENTS' ?
                                    'ගෙවිය යුතු පළමු වාරිකයේ මුදල  :  ' + this.props.courseDetails.courseInstallmentList[0].amount + '/=' :
                                    'එකවර ගෙවිය යුතු මුදල  :  ' + this.props.courseDetails.totalFee + '/='
                                }</p> : null}
                        </Col>

                        <Col xs={12}>
                            <div>
                                <Button className="log-btn com-btn"
                                        color="red" onClick={this.setEnrollment}>
                                    {language[lang].payAndRegisterToCourse}
                                </Button>
                            </div>
                        </Col>

                    </Row>
                </Modal.Content>

            </Modal>
        )
    }
}

export default getPaymentModel;